import React, { ReactNode, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronDown, ChevronUp } from 'react-feather';
import styles from './ExpandableBox.module.css';
import { Button } from '../button';

interface ExpandableBoxProps {
  title: string | ReactNode;
  children: ReactNode;
}

function ExpandableBox({ title, children }: ExpandableBoxProps) {
  const [expanded, setExpanded] = useState(false);
  const [showButton, setShowButton] = useState(false);

  const { t } = useTranslation();
  const contentRef = useRef<HTMLDivElement>(null);
  const maxHeight = 400;

  useEffect(() => {
    if (contentRef.current && contentRef.current.scrollHeight > maxHeight) {
      setShowButton(true);
    } else {
      setShowButton(false);
    }
  }, [children]);

  const toggleExpand = () => {
    setExpanded(!expanded);
  };

  return (
    <div className={styles.expandableBox}>
      <div className={styles.title}>{title}</div>
      <div
        ref={contentRef}
        className={`${styles.content} ${expanded ? styles.expanded : ''} ${!showButton ? styles.noBorder : ''}`}
        style={{ maxHeight: expanded ? 'none' : `${maxHeight}px` }}
      >
        {children}
      </div>
      {showButton && (
        <div className={styles.footer}>
          <Button theme="plain" onClick={toggleExpand}>
            {expanded ? (
              <>
                <span>{t('collaborations.hide')}</span>
                <ChevronUp size={20} />
              </>
            ) : (
              <>
                <span>{t('collaborations.showMore')}</span>
                <ChevronDown size={20} />
              </>
            )}
          </Button>
        </div>
      )}
    </div>
  );
}

export { ExpandableBox };
